<span class="lesson-status-icon"
  [ngClass]="iconClass"
  role="img"
  [attr.aria-label]="ariaLabel">
  @if (showCheckmark) {
    <svg class="icon-checkmark" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M10 3L4.5 8.5L2 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  }
  @if (showNumber) {
    <svg class="icon-number-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <text
        x="12"
        y="16.7"
        text-anchor="middle"
        fill="currentColor"
        font-family="'proxima-nova', sans-serif"
        font-weight="700"
      font-size="13">{{ lessonNumber }}</text>
    </svg>
  }
  @if (showLock) {
    <i class="icon-lock" aria-hidden="true"></i>
  }
</span>
